import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'cv-lock-icon-cell-renderer',
  template: `
    <div><svg [ngbPopover]="popoverText" popoverClass="CXoneMgtPopover" placement="left" triggers="mouseenter:mouseleave" container="body" [openDelay]="400" *ngIf="params.data?.IsEditable == false" class="icon-12 fill-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/lock.svg#lock"></use></svg></div>
  `,
  styleUrls: ['./lock-icon-cell-renderer.component.scss']
})
export class LockIconCellRendererComponent implements AgRendererComponent {

  public params: any;
  public popoverText: string;

  constructor() { }
  refresh(params: any): boolean {
    return false;
  }
  agInit(params: any): void {
    this.params = params;
    this.popoverText = params.popover;

  }

  ngOnInit(): void {
  }

}
